import React, { useState } from 'react';
import { Mail, Phone, MapPin, MessageCircle, Send } from 'lucide-react';

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    interest: 'general'
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Aquí se conectaría con el backend o servicio de email
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section className="contact-section">
      <div className="container">
        <h2 className="section-title">Contáctanos</h2>
        <p className="section-subtitle">
          ¿Te interesa conocer más sobre nuestras carteras o tienes alguna pregunta?
          ¡Nos encantaría escucharte!
        </p>

        <div className="contact-content">
          <div className="contact-info">
            <h3>Información de Contacto</h3>

            <div className="contact-methods">
              <div className="contact-method">
                <Mail size={24} />
                <div>
                  <h4>Email</h4>
                  <p>hola@segundavida.com</p>
                </div>
              </div>

              <div className="contact-method">
                <Phone size={24} />
                <div>
                  <h4>Teléfono</h4>
                  <p>+51 xxx-xxx-xxx</p>
                </div>
              </div>

              <div className="contact-method">
                <MapPin size={24} />
                <div>
                  <h4>Ubicación</h4>
                  <p>Lima, Perú</p>
                </div>
              </div>

              <div className="contact-method">
                <MessageCircle size={24} />
                <div>
                  <h4>WhatsApp</h4>
                  <p>Envíanos un mensaje directo</p>
                </div>
              </div>
            </div>

            <div className="social-note">
              <p>
                <strong>¿Sabías que...?</strong> Nuestras anillas vienen directamente
                de nuestro restaurante de ceviches. ¡Ven a visitarnos y conoce el
                origen de nuestras carteras!
              </p>
            </div>
          </div>

          <div className="contact-form">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Nombre</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="interest">Me interesa</label>
                <select
                  id="interest"
                  name="interest"
                  value={formData.interest}
                  onChange={handleChange}
                >
                  <option value="general">Información general</option>
                  <option value="purchase">Comprar una cartera</option>
                  <option value="custom">Pedido personalizado</option>
                  <option value="collaboration">Colaboración</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Mensaje</label>
                <textarea
                  id="message"
                  name="message"
                  rows={5}
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Cuéntanos en qué podemos ayudarte..."
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-button">
                <Send size={18} />
                Enviar Mensaje
              </button>
            </form>
          </div>
        </div>

        <footer className="site-footer">
          <p>&copy; 2024 Segunda Vida. Transformando residuos en arte.</p>
          <p className="footer-tagline">
            "Recicla lo que puedas reciclar y crea" ♻️
          </p>
        </footer>
      </div>
    </section>
  );
};

export default Contact;